import { AioExternalReplacements, AioReplacement } from "aic";
import { hasStylesInReplacementValues } from "./hasStylesInReplacementValues";

/**
 * Determines whether an external replacement list should be merged with an internal replacement.
 * External lists are merged only when they contain styles that need to be removed (Optional, OptionalLocked, or Notes).
 * This check is performed recursively, including any nested sublists.
 *
 * @template T - Content type for replacement texts
 * @param replacement - The internal replacement that may reference an external list
 * @param externalLists - Optional array of external replacement lists
 * @returns True if an external list should be merged; false otherwise
 */
export const shouldMergeExternal = <T>(
  replacement: AioReplacement<T>,
  externalLists?: AioExternalReplacements<T>[],
): boolean => {
  // Find matching external list if this replacement references one
  const externalList = externalLists?.find(
    (ext) => replacement.externalName && ext.givenName === replacement.externalName,
  );

  // Check if external list contains styles that need removal (recursively checks sublists)
  return externalList ? hasStylesInReplacementValues(externalList.newTexts) : false;
};
